import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AgentsNotReadyDemoService {

  private _agentsNotReadyContext: IAgentNotReady;

    constructor() { 
      this._agentsNotReadyContext = {
        Name: "name",
        Location: "",
        LastUpdated: "",
        Items: [
          { Name: 'Agent 1', Description: "Documenting", Time: "00:48:11", Supervisor: "", UpdateDateTime: "", WarningLevel: 1, WarningTime: "" },
          { Name: 'Agent 2', Description: "Pull Mode", Time: "00:14:08", Supervisor: "", UpdateDateTime: "", WarningLevel: 1, WarningTime: "" },
          { Name: 'Agent 3', Description: "10 Minute Break", Time: "00:14:08", Supervisor: "", UpdateDateTime: "", WarningLevel: 1, WarningTime: "" },
          { Name: 'Agent 4', Description: "Bathroom", Time: "00:10:08", Supervisor: "", UpdateDateTime: "", WarningLevel: 1, WarningTime: "" },
          { Name: 'Agent 5', Description: "30 Minute Lunch", Time: "00:40:08", Supervisor: "", UpdateDateTime: "", WarningLevel: 1, WarningTime: "" },
          { Name: 'Agent 6', Description: "30 Minute Lunch", Time: "00:10:08", Supervisor: "", UpdateDateTime: "", WarningLevel: 0, WarningTime: "" },
          { Name: 'Agent 6', Description: "Training", Time: "01:10:08", Supervisor: "", UpdateDateTime: "", WarningLevel: 0, WarningTime: "" },
          { Name: 'Agent 7', Description: "Training", Time: "01:20:08", Supervisor: "", UpdateDateTime: "", WarningLevel: 0, WarningTime: "" },
        ]
      };
    }
  
    get() {
      return of(this._agentsNotReadyContext);
    }
  }

  export interface IAgentNotReady {
    Name: string,
    Location: string,
    LastUpdated: string,
    Items: IAgntItem[]
  }

  interface IAgntItem {
    Name: string,
    Description: string,
    Time: string,
    Supervisor: string,
    UpdateDateTime: string,
    WarningLevel: number,
    WarningTime: string
  }

